import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import { PortalHelpProvider } from "portal-help"
import App from "./App"
import store from "./store/store"
import "./index.css"
import { initNumberInputArrowPrevention } from "./utils/disableNumberInputArrows"

const container = document.getElementById("root")

if (container) {
  const root = createRoot(container)

  // Initialize number input arrow prevention
  initNumberInputArrowPrevention()

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <PortalHelpProvider
            portalSlug="admin-portal"
            portalTitle="Admin Portal"
            apiBaseUrl={window.env?.DOCUMENTATION_API_URL}
          >
            <App />
          </PortalHelpProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
  )
} else {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  )
}
